<template>
    <v-container fluid style="padding: 20px">

        <v-list   class="c-grey text-left">
            <v-list-item-title style= 'color:blue' >Uygunluk Anketi Sonucu {{ uygTitle }} </v-list-item-title>
            <v-list-item 
            v-for="item in recommendedProductsUYG"
            :key="item"
            >
            {{ "•  " + item }}
            </v-list-item>          
            <v-list-item style='font-weight: bold; color: cornflowerblue;'>{{ uygTitle2 }}</v-list-item>
        </v-list>
        <v-list   class="c-grey text-left">
          <v-list-item-title style= 'color:green' >Yerindelik Anketi Sonucu {{ "(Puan : " + scoringResultPointYER + ")"}}</v-list-item-title>
            <v-list-item 
            v-for="item in recommendedProductsYER"
            :key="item"
            >
            {{ "•  " + item }}
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>

export default {
  name: "questionary-result",
  data () {
  return {
      recommendedProductsUYG: "",
      recommendedProductsYER: "",
      unRecommendedProductsUYG: "",
      scoringResultPointUYG: null,
      scoringResultPointYER: null,
      notSuitableButtonClicked: null,
      uygTitle: "",
      uygTitle2: ""
    }
  },
  props: {
    processVariablesList: {
      type: Array,
      default: () => []
    }
  },
  created () {
    this.filterProcessVariables();
  },
  watch: {
    processVariablesList: function() {
    this.filterProcessVariables();
    }
  },
  methods: {
    filterProcessVariables() {
      if (this.processVariablesList != null && this.processVariablesList.length > 0){
        debugger;
        const tempRecommendedProductsUYG = this.processVariablesList.find(x => x.code == "recommendedProductsList_UYG")
        if (tempRecommendedProductsUYG != null && tempRecommendedProductsUYG.value != null){
          this.recommendedProductsUYG = tempRecommendedProductsUYG.value.split("|");
        }
        const tempUnRecommendedProductsUYG = this.processVariablesList.find(x => x.code == "unRecommendedProductsList_UYG")
        if (tempUnRecommendedProductsUYG != null && tempUnRecommendedProductsUYG.value != null){
          this.unRecommendedProductsUYG = tempUnRecommendedProductsUYG.value.split("|");
        }
        const tempRecommendedProductsYER = this.processVariablesList.find(x => x.code == "recommendedProductsList_YER")
        if (tempRecommendedProductsYER != null && tempRecommendedProductsYER.value != null){
          this.recommendedProductsYER = tempRecommendedProductsYER.value.split("|");
        }
        const tempScoringResultPointUYG = this.processVariablesList.find(x => x.code == "scoringResultPoint_UYG")
        if (tempScoringResultPointUYG != null && tempScoringResultPointUYG.value != null){
          //this.scoringResultPointUYG = tempScoringResultPointUYG.value;
          this.uygTitle = "(Puan : " +  tempScoringResultPointUYG.value + ")";
        }
        const tempScoringResultPointYER = this.processVariablesList.find(x => x.code == "scoringResultPoint_YER")
        if (tempScoringResultPointYER != null && tempScoringResultPointYER.value != null){
          this.scoringResultPointYER = tempScoringResultPointYER.value;
        }
        const tempNotSuitableButtonClicked = this.processVariablesList.find(x => x.code == "notSuitableButtonClicked")
        if (tempNotSuitableButtonClicked != null && tempNotSuitableButtonClicked.value != null && tempNotSuitableButtonClicked.value == "true"){
          //this.notSuitableButtonClicked = tempNotSuitableButtonClicked.value;
          this.unRecommendedProductsUYG.forEach(element => {
            element =  element + " **"
            this.recommendedProductsUYG.push(element);
          });
          //this.recommendedProductsUYG = this.recommendedProductsUYG.concat(this.unRecommendedProductsUYG);
          this.uygTitle2 = "** Uygun olmayan ürün ve hizmetlerin riski kabul edilmiştir."
        }
      }
    },
    listToArray() {
      if (this.recommendedProductsUYG != null && this.recommendedProductsUYG.length > 0){
        this.basicListArray = this.basicListItems.split("|") ;
      }
    }
  }
  

};

</script>


// WEBPACK FOOTER //
// src/components/QuestionaryResult.vue